import React from 'react';
import { FadeIn } from './ui';
export const Hook = () => {
  return <section className="py-16 px-6" data-id="element-66">
      <div className="max-w-2xl mx-auto" data-id="element-67">
        <FadeIn data-id="element-68">
          <p className="font-serif text-2xl md:text-3xl leading-relaxed text-parchment text-center mb-8" data-id="element-69">
            You know the feeling. <br data-id="element-70" />
            <span className="italic text-amber" data-id="element-71">It’s 3:14 AM.</span> <br data-id="element-72" />
            The room is silent, but your head is screaming.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-73">
          <div className="space-y-6 text-parchment-muted font-light leading-loose text-lg" data-id="element-74">
            <p data-id="element-75">
              You’ve flipped the pillow for the fourth time. You’ve calculated
              exactly how many hours of sleep you’ll get if you "just fall
              asleep right now."
            </p>
            <p data-id="element-76">
              But the more you try to relax, the faster your heart beats. Your
              brain is re-litigating a conversation from three years ago and
              worrying about an email you haven’t even received yet.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};